import Peers from "@/modules/Peers";
import Xmpp from "@/modules/Xmpp";
import { peerEmitter } from "@/modules/events/emitter";
import { isPairedDevice } from "@/utils";
import type CameraRtcManager from "camera/modules/CameraRtcManager";
import { stationStore } from "camera/store/station";

const RECONNECT_TIMEOUT = 60 * 1000;

const saveMonitoringViewers = () => stationStore().setMonitoringViewers(Object.keys(Peers.getAll()));

const removeIfNotReconnected = (rtcManager: CameraRtcManager, jid: string, peerConnection: Peer["peerConnection"]) => {
  const isRestoredPeer = Peers.get(jid)?.peerConnection === peerConnection;
  if (!isRestoredPeer || peerConnection?.connectionState === "connected") return;

  log.monitoring("Viewer didn't reconnect after the restart, removing its peer", jid);
  rtcManager.rtc.destroyPeerConnection(jid);
  const isCameraOn = stationStore().recordingMode === "ON";
  if (Peers.getAllAsArray().length === 0 && isCameraOn) Xmpp.getInstance().sendPresence("sender");
};

export const restoreMonitoringViewers = (rtcManager: CameraRtcManager) => {
  const isCameraOn = stationStore().recordingMode === "ON";
  const viewers = isCameraOn
    ? stationStore().monitoringViewers.filter((jid) => !Peers.get(jid) && isPairedDevice(jid))
    : [];

  saveMonitoringViewers();
  peerEmitter.on("peer-added", saveMonitoringViewers);
  peerEmitter.on("peer-removed", saveMonitoringViewers);

  viewers.forEach((jid) => {
    log.monitoring("Restoring peer of viewer that was watching before the restart", jid);
    const { peerConnection } = rtcManager.rtc.initializePeer(jid);
    setTimeout(() => removeIfNotReconnected(rtcManager, jid, peerConnection), RECONNECT_TIMEOUT);
  });
  return viewers;
};
